import React from "react";
import { Routes, Route } from "react-router-dom";
import CartDashboard from "./CartDashboard";
import CartList from "./CartList/CartList";
import CartDetails from "./CartDetails/CartDetails";
import ExchangeItemsList from "./ExchangeItems/ExchangeItemsList";
import ExchangeItemVerification from "./ExchangeItems/ExchangeItemVerification/ExchangeItemVerification";
import CartAnalytics from "./Analytics/CartAnalytics";
import AbandonedCarts from "./Analytics/AbandonedCarts";

const CartRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CartDashboard />} />
      <Route path="/list" element={<CartList />} />
      <Route path="/details/:cartId" element={<CartDetails />} />
      <Route path="/exchange-items" element={<ExchangeItemsList />} />
      <Route
        path="/exchange-items/:cartId/:itemId"
        element={<ExchangeItemVerification />}
      />
      <Route path="/analytics" element={<CartAnalytics />} />
      <Route path="/abandoned" element={<AbandonedCarts />} />
    </Routes>
  );
};

export default CartRoutes;
